import CardHeader from "../../atoms/CardHeader";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../molecules/Breadcrumb";

const HerramientasTemplate = () => {
    const { id } = useParams();

    return(
        <div className="w-full h-full space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Empresa", to: `/clientes/empresas/${id}` },
                        { label: "HERRAMIENTAS", to: null },
                    ]}
                />
            </CardHeader>
            <p>
                En esta sección encontrarás herramientas que te ayudarán en tu contabilidad.
            </p>
        </div>
    );
};

export default HerramientasTemplate;